import AEWLogo from '../../img/AEWLogo.svg';

const Header = () => {
  return (
    <div className="AppHeader container d-flex justify-content-left" style={{ maxWidth: '1400px' }}>
      <img className="Logo" src={AEWLogo} alt="AEW Logo"></img>
    </div>
  );
}

export default Header;
